function n(e){return Number.isSafeInteger(e)&&e>=0}export{n as isLength};
